import Vue from 'vue';
import { IonicVueRouter } from '@ionic/vue';
import firebase from 'firebase/app';
import 'firebase/auth';
import {func} from './func.js'
// import Home from './views/Home.vue';


import newSolicitud from './views/newSolicitud.vue'
import Login from './views/Login.vue'
import Solicitudes from './views/solicitudes.vue'
import SolicitudesFinalizadas from './views/finalizadas.vue'
import solicitudesStatus from './views/solicitudesStatus' 

// import loginDesktop from './views/LoginDesktop'
import BackOffice from './views/backOffice'
import LoginDesktop from './views/loginDesktop'
import BackOfficeUsuarios from './views/BackOfficeUsuarios'
import BackOfficeUnidadOperadores from './views/BackOfficeUnidadOperadores'

Vue.use(IonicVueRouter);
// import TimeLine from './views/TimeLine.vue'
// import UsrSol from './views/UsrSolicitudes.vue'
// import AdminSol from './views/AdminSolicitudes.vue'


let mobileRoutes = [
  {
    path: '*',
    component: Solicitudes,
    // component: showSping,
    meta:{
      requiresAuth: false
    }
  },
  {
    path: '/',
    name: 'home',
    component: Solicitudes,
    // component: showSping,
    meta:{
      requiresAuth: false
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta:{
      requiresAuth: false
    }
  },    
  {
    path: '/solicitudes',
    name: 'solicitudes',
    component: Solicitudes,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/solicitudes-finalizadas',
    name: 'finalizadas',
    component: SolicitudesFinalizadas,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/pendiente/:tipo',
    name: 'solicitudesStatus',
    component: solicitudesStatus,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/nueva-solicitud',
    name: 'newSolicitud',
    component: newSolicitud,
    meta: {
      requiresAuth: true
    }
  }
]

let desktopRoutes = [
  {
    path: '*',
    component: LoginDesktop,
    // component: showSping,
    meta:{
      requiresAuth: false
    }
  },
  {
    path: '/iniciar',
    component: LoginDesktop,
    // component: showSping,
    meta:{
      requiresAuth: false
    }
  },
  {
    path: '/back-office',
    component: BackOffice,
    // component: showSping,
    meta:{
      requiresAuth: false
    }
  },
  {
    path: '/back-office/usuarios',
    component: BackOfficeUsuarios,
      // component: showSping,
    meta:{
      requiresAuth: false
     }
  },
  {
    path: '/back-office/unidad_operadores',
    component: BackOfficeUnidadOperadores,
      // component: showSping,
    meta:{
      requiresAuth: false
     }
  },
]

let _rutas = ( func.isMobile() ) ? mobileRoutes: desktopRoutes;



const router = new IonicVueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: _rutas
});

// router.beforeEach((to, from, next) => {
router.beforeEach((to, from, next) => { // el router es manejado por 
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  
  // console.log(currentUser)
  if( ! requiresAuth )
    next();
  else if( requiresAuth  && currentUser)
    next();
  else
    next('/');
  // if ( currentUser == null ) {
  //   console.log("No exite Usuario");
  //   next();
  // }
  // else if ( requiresAuth && currentUser){
  //   console.log("Existen las dos ");//next('/solicitudes');
  //   next();
  // }
  // else{ 
  //   console.log("Default"); //next("home");
  //   next();
  // }
});





if( func.isMobile() ){
  /* No Desktop  */
  console.log("Es mobile");
}else{
  /* Is Desktop  */
  console.log("No es mobile");
}
export default router;
